<template>
  <v-scale-screen width="1920" height="1080">
    <div class="main"
         style="width: 1920px;height:1080px;box-sizing: border-box;display: flex;justify-content: center;align-items: center">
      <div
          style="width: 1158px;height: 484px;background: #FFFFFF;display: flex;justify-content: space-between;align-items: center">
        <div class="login-left" style="width: 674px;height: 484px;background-color:#002749; ">
          <div style="font-size: 36px;color: #FFFFFF;margin-top: 48.5px;font-family: HelloFont WenYiHei;">
            吉华衬塑数字车间数据大屏
          </div>
        </div>
        <div class="login-right"
             style="width: 484px;height: 484px;display: flex;align-items: center;flex-direction: column;justify-content: center">

          <div style="width: 269px;display: flex;align-items: center;flex-direction: column">
            <div style="width: 269px; font-size: 24px;color: #002749;">登录</div>
            <div style="width: 269px">
              <el-form ref="form" :model="form" label-width="45px" style="margin-top: 42px">
                <el-form-item label="账号">
                  <el-input v-model="form.account" @keydown.enter.native="login"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                  <el-input v-model="form.password" @keydown.enter.native="login" show-password></el-input>
                </el-form-item>
              </el-form>
            </div>

            <div style="width: 100%;text-align: right">
              <el-checkbox v-model="checked">记住密码</el-checkbox>
            </div>
            <div @click="login"
                 style="cursor: pointer; margin-top: 30px; width: 100%;font-size: 16px;color: #FFFFFF;height: 40px;text-align: center;line-height: 40px;background: #002749;">
              登录
            </div>
            <div style="font-size: 12px;color: #999999;margin-top: 14px;">忘记密码请联系开发者</div>
          </div>
        </div>
      </div>
    </div>
  </v-scale-screen>

</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: 'HomeView',
  components: {},
  data() {
    return {
      checked: false,
      form: {
        account: "",
        password: ""
      }
    }
  },
  methods: {
    login() {
      if (this.form.account === '' || this.form.password === '') {
        this.$message({
          showClose: true,
          message: '请填写账号和密码',
          type:"error"
        });
      } else {
        // axios.create({
        //   baseURL: 'http://plc.yunminet.site/adminapi/',
        //   headers: {
        //     'Content-Type': 'application/json',
        //     "token": localStorage.getItem('token')
        //   }
        // })
        try{
          axios.post("https://plc.yunminet.site/adminapi/login/account",{
            account: this.form.account,
            password: this.form.password,
            terminal:1,
          }).then(res => {
            console.log(res.data)
            if(res.data.code===1){
              localStorage.setItem('token',res.data.data.token)
              this.$message({
                showClose: true,
                message: '登录成功',
                type:"success"
              });
              this.$router.push('/')
            }else{
              console.log(res)
              this.$message({
                showClose: true,
                message: res.data.msg,
                type:"error"
              });
            }
          })
        }catch(error){
          this.$message({
            showClose: true,
            message: error,
            type:"error"
          });
        }


      }
    },

  },
}
</script>
<style scoped>
.main {
  background-image: url("@/assets/loginback.png");
  background-size: 100% 110%;
  background-position: center top -10px;
}

.login-left {
  background-image: url("@/assets/loginleft.png");
  background-size: 100% 100%;
}

::v-deep .el-input__inner {
  background: #F3F3F3;
  border: none !important;
  width: 226px !important;
}


::v-deep .el-form-item__label {
  color: #002749 !important;
  font-size: 16px !important;
}
</style>
